<template src="@/templates/document/resourceDetail.html"></template>

<script>
import { mapActions } from "vuex";
import ResourceModel from "@/models/resourceModel";
// import resourceModel from "../../models/resourceModel";

export default {
  name: "resourceDetail",
  props: ["id", "parentComp"],
  data() {
    return {
      resourceModel: new ResourceModel(),
    };
  },
  created() {
    this.updateHideAll();
    this.updateBackButton(true);
    this.updateReturnToComp(this.parentComp);
    this.fetchResourceDetail();
  },
  methods: {
    ...mapActions(["updateHideAll", "updateBackButton", "updateReturnToComp"]),
    fetchResourceDetail() {
      this.resourceModel
        .getDetail(this.id)
        .then((resourceModelRes) => {
          let result = resourceModelRes.response.data;

          if (result.error === true) {
            this.fetchError(result.message);
          }

          this.resourceModel.data = result.data;
        })
        .catch((PCError) => {
          let errorMessage = "Network error. " + PCError;
          this.fetchError(errorMessage);
          console.error(PCError);
        });
    },
    fetchError(errorMessage) {
      this.$vs.notify({
        title: "Network Error",
        text: errorMessage,
        time: 4000,
        color: "danger",
        position: "top-center",
      });
    },
    getImage() {
      return (
        this.$interpretersApiUrl +
        this.resourceModel.getRoute("view") +
        localStorage.getItem("jwt") +
        "&irID=" +
        this.resourceModel.id
      );
    },
    openLink(url) {
      if (url) {
        window.open(url);
      } else {
        this.$vs.notify({
          title: "Information",
          text: "No link available",
          time: 4000,
          color: "warning",
          position: "top-center",
        });
      }
    },
  },
};
</script>
